import React from "react";
import { Loader2, Tag, X } from "lucide-react";
import { Input } from "@/components/ui/input";

export const CouponField = ({ couponCode, setCouponCode, coupon, onApply, onClear, loading, idPrefix = "" }) =>
  !coupon ? (
    <div className="flex gap-2">
      <div className="relative flex-1">
        <Tag className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-faint" aria-hidden="true" />
        <Input value={couponCode} onChange={(e) => setCouponCode(e.target.value.toUpperCase())} placeholder="Coupon code" data-testid={`${idPrefix}coupon-input`} className="h-11 pl-9 focus-visible:ring-brand" />
      </div>
      <button type="button" onClick={onApply} disabled={loading} data-testid={`${idPrefix}coupon-apply`} className="rounded-xl border border-ink px-4 text-sm font-medium text-ink hover:bg-ink hover:text-white transition-colors disabled:opacity-50">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Apply"}
      </button>
    </div>
  ) : (
    <div className="flex items-center justify-between rounded-xl bg-brand-soft text-brand-dark px-4 py-2.5 text-sm font-medium" data-testid={`${idPrefix}coupon-applied`}>
      <span className="inline-flex items-center gap-2"><Tag className="w-4 h-4" aria-hidden="true" /> {coupon.code} applied</span>
      <button type="button" onClick={onClear} aria-label="Remove coupon"><X className="w-4 h-4" /></button>
    </div>
  );

export default CouponField;
